import React, { Fragment } from 'react';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { Link } from '../../link';
export function ScheduleDisplayInfo(props) {
  var displayInfo = props.displayInfo,
      onClearAll = props.onClearAll,
      renderDisplayInfo = props.renderDisplayInfo,
      renderEmpty = props.renderEmpty,
      disabled = props.disabled;
  var localeSeparator = useLocale('schedule.separator');
  var prefix = 'schedule-display';
  var cls = usePrefixCls(prefix);
  var emptyCls = usePrefixCls(prefix, {
    empty: true
  }, true);
  var headerCls = usePrefixCls(prefix, {
    header: true
  }, true);
  var clearCls = usePrefixCls(prefix, {
    clear: true
  }, true);
  var infoCls = usePrefixCls(prefix, {
    info: true
  }, true);
  var infoLabelCls = usePrefixCls(prefix, {
    'info-label': true
  }, true);
  var infoTextCls = usePrefixCls(prefix, {
    'info-text': true
  }, true);
  var localeClear = useLocale('schedule.clear');
  var localeSelected = useLocale('schedule.selected');

  var renderInfoItem = function renderInfoItem(data) {
    if (renderDisplayInfo) {
      return renderDisplayInfo(data);
    }

    return React.createElement(Fragment, null, React.createElement("span", {
      className: infoLabelCls
    }, data.label), React.createElement("span", {
      className: infoTextCls
    }, data.value.join(localeSeparator)));
  };

  var info = displayInfo.filter(function (item) {
    return !!item.value.length;
  });

  if (!info.length) {
    return React.createElement("div", {
      className: cls
    }, typeof renderEmpty === 'function' ? renderEmpty() : React.createElement("div", {
      className: emptyCls
    }, "Drag the mouse to select the time period"));
  }

  return React.createElement("div", {
    className: cls
  }, React.createElement("div", {
    className: headerCls
  }, localeSelected, React.createElement(Link, {
    disabled: disabled,
    className: clearCls,
    onClick: onClearAll
  }, localeClear)), info.map(function (item) {
    return React.createElement("div", {
      key: item.label + '' + item.value.join(','),
      className: infoCls
    }, renderInfoItem(item));
  }));
}